// extracted by mini-css-extract-plugin
export default {"actionWrap":"SapAction_actionWrap__hjmvB"};